<template>
  <div class="layout1 pointList" style="background: #f4f6f8">
    <div class="intes-bt">报告对比</div>
    <div class="intes-bg bgBox">
      <div class="bgBoxtit">
        肠动力动态趋势图
        <ul>
          <li>
            <span></span>
            减弱
          </li>
          <li>
            <span></span>
            普通
          </li>
          <li>
            <span></span>
            加强
          </li>
        </ul>
      </div>
      <div class="bgBoxtb">
        <echarts-bar :barlist.sync="barlist"></echarts-bar>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item
        :name="index"
        v-for="(item, index) in list"
        :key="index"
      >
        <template #title>
          <div class="pointImg">
            <img :src="require(`@/assets/image/chang/${item.name}.png`)" />{{
              item.name
            }}
          </div>
        </template>
        <noteTable :list="item.child"></noteTable>
      </van-collapse-item>
    </van-collapse>
    <ball :text="'返回'"></ball>
  </div>
</template>
<script>
import EchartsBar from './components/EchartsBar'
import noteTable from './components/noteTable'
import ball from "./components/ball.vue"
import Report from "../../models/Report";
import { Toast } from 'vant';
export default {
  components: { EchartsBar, noteTable, ball },
  data () {
    return {
      activeNames: [],
      barlist: [],
      list: [
      ]
    }
  },
  computed: {
    user_no () {
      return this.$route.query.user_no || "";
    },
    test_report_id () {
      return this.$route.query.test_report_id || "";
    },
  },
  created () {
    let params = {
      user_no: this.user_no,
      test_report_id: this.test_report_id.replace("[", "").replace("]", "")
    };
    Report.getContrast({ ...params }, (res, err) => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
        className: 'tianlei',
        loadingType: 'spinner',
      });
      if (!err) {
        this.barlist = res.z_list
        this.list = res.qiguan_list
        setTimeout(() => {
          Toast.clear()
        }, 1500)


      }
    });

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.bgBox {
  padding: 20px 20px 0 20px;
  .bgBoxtb {
    margin-top: -40px;
  }
}
.intes-bt {
  padding: 24px 20px;
  font-size: 30px;
  color: #333;
  text-align: center;
}
.intes-cjfx {
  padding: 30px;

  background: #f4faff;
  font-size: 26px;
  div {
    margin-bottom: 30px;
  }
  div:last-child {
    margin-bottom: 0;
  }
  h3 {
    color: #3195e6;
    margin: 0;
  }
  p {
    color: #333;
    margin: 0;
  }
}
</style>